import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { SERVICES } from "@/mock";
import { TestList } from "../test/TestList";

const safeScrollToId = (id) => {
    if (typeof document === "undefined") return;
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const TestsSection = () => {
    return (
        <section id="tests" className="pt-12 py-16 bg-olive-50 relative overflow-hidden">
            <div
                className="absolute z-0 overflow-hidden right-0 top-0 w-[90vw] md:w-[70vw] h-[50vh] bg-no-repeat bg-bottom bg-contain pointer-events-none"
                style={{ backgroundImage: "url('/image/svg/vetka-2.svg')", transform: "rotateZ(180deg)" }}
            />
            <div className="relative z-5 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <h2 className="font-serif pt-12 text-3xl text-olive-950">
                    Тесты
                </h2>

                <p className="mt-2 text-olive-900/70 text-sm animate-in slide-in-from-top duration-1000 delay-300">
                    Пройдите тесты для определения вашего текущего психологического состояния.
                </p>

                <TestList card className="md:flex-row items-stretch" />
            </div>
        </section>
    );
};
